import type { ReactNode } from 'react';
import { Pressable, View } from 'react-native';
import { useRouter } from 'expo-router';

import { Text } from '@/components/ui';
import { cn } from '@/lib/design-system/cn';

export type MasterSection = 'currencies' | 'accounts' | 'fx' | 'categories';

const SECTIONS: { key: MasterSection; label: string; href: string }[] = [
  { key: 'accounts', label: 'Accounts', href: '/finance/master/accounts' },
  { key: 'currencies', label: 'Currencies', href: '/finance/master/currencies' },
  { key: 'fx', label: 'FX Rates', href: '/finance/master/fx' },
  { key: 'categories', label: 'Categories', href: '/finance/master/categories' },
];

export function MasterDataShell({
  active,
  children,
}: {
  active: MasterSection;
  children: ReactNode;
}) {
  const router = useRouter();
  return (
    <View className="flex-1">
      <Text variant="h2">Master data</Text>
      <Text variant="body-sm" className="mt-1 text-muted">
        Reference data you set up once and edit rarely.
      </Text>
      <View className="mt-4 flex-row flex-wrap gap-1 border-b border-border pb-2">
        {SECTIONS.map((section) => {
          const isActive = section.key === active;
          return (
            <Pressable
              key={section.key}
              className={cn('rounded-md px-3 py-1.5', isActive ? 'bg-surface-raised' : '')}
              onPress={() => router.push(section.href)}
            >
              <Text
                variant="body-sm"
                className={isActive ? 'font-semibold text-accent' : 'text-muted'}
              >
                {section.label}
              </Text>
            </Pressable>
          );
        })}
      </View>
      <View className="mt-5">{children}</View>
    </View>
  );
}
